import styled from "@emotion/styled"
import { Button, Text, theme } from "@pallet-hq/hegel"
import React from "react"
import { FiArrowLeft, FiEdit2 } from "react-icons/fi"
import { VerticallyCenteredBox } from "components/atoms"
import Image from "components/Image"
import NextLink from "components/Link/NextLink"
import PostEditorModal from "features/job-posts/editor/views/PostEditorModal"
import useJobPostEditorModal from "state/useJobPostEditorModal"
import { useBackPageRoute } from "utils/hooks/useBackParams"
import { usePalletContext } from "utils/hooks/usePalletContext"
import { PostInfoProps } from "."

const PostBackButton = (props: PostInfoProps) => {
    const backPage = useBackPageRoute()
    const { pallet } = usePalletContext()
    const { setPost, showModal } = useJobPostEditorModal()

    if (!backPage?.applylist) return null

    const backHref = pallet ? "/jobs" : `/list/${backPage.applylist.slug}/jobs`
    const handleEditClick = () => {
        setPost(props.post.uuid)
        showModal()
    }

    return (
        <>
            <VerticallyCenteredBox
                justifyContent="space-between"
                mb="medium"
                width="100%"
            >
                <NextLink href={backHref} passHref>
                    <VerticallyCenteredBox
                        gap={theme.space.xsmall}
                        py="xxsmall"
                        style={{ cursor: "pointer" }}
                    >
                        <FiArrowLeft
                            size={theme.space.medium}
                            stroke={theme.colors.gray900}
                        />
                        <StyledImage
                            width={24}
                            height={24}
                            src={backPage.applylist.logo?.source}
                            colorSlug={backPage.applylist.slug}
                            borderRadius={theme.space.xxsmall}
                        />
                        <Text variant="paragraphMedium">
                            {backPage?.applylist.name}
                        </Text>
                    </VerticallyCenteredBox>
                </NextLink>
                {props.post.canEdit && (
                    <Button
                        variant="secondary"
                        size="xsmall"
                        onClick={handleEditClick}
                    >
                        <VerticallyCenteredBox gap={theme.space.xsmall}>
                            <FiEdit2 size={theme.space.small} />
                            Edit job post
                        </VerticallyCenteredBox>
                    </Button>
                )}
            </VerticallyCenteredBox>
            <PostEditorModal />
        </>
    )
}

export default PostBackButton

const StyledImage = styled(Image)`
    object-fit: cover;
`
